export * from "./terms-conditions.component";
